<template>
  <div>

    <cg-user-header></cg-user-header>

    <div class="container" >
      <div class="bg-default">
        <div class="btn-menu one-page-menu flex bg-white">
          <div class="inline-flex sm:block">
            <button @click.prevent="changeTab('profile')" :class="['btn', 'icon', tab === 'profile' ? 'active' : '', 'bg-white hover:bg-red text-grey-darkest hover:text-white font-bold py-2 px-10 sm:w-full']">
              <span><icon class="icon" name="user"></icon></span><span>Mein Profil</span></button>
            <button @click.prevent="changeTab('orders')" :class="['btn', 'icon', tab === 'orders' ? 'active' : '', 'bg-white hover:bg-red text-grey-darkest hover:text-white font-bold py-2 px-10 sm:w-full']">
              <span><icon class="icon" name="shopping-cart"></icon></span><span>Meine Bestellungen</span></button>
          </div>
        </div>
          <!-- <button @click.prevent="changeTab('favorites')" :class="['btn', 'icon', tab === 'favorites' ? 'active' : '']" ><span><icon class="icon" name="star-o"></icon></span><span>Meine Favoriten</span></button> -->
      </div>
      <div class="space"></div>
    </div>

    <profile v-show="tab === 'profile'" ></profile>

    <!--<favorites v-show="tab === 'favorites'"></favorites> -->

    <orders v-show="tab === 'orders'" ></orders>

    <cgfooter></cgfooter>

  </div>
</template>

<script>
  import Navbar from '../components/Navbar.vue'
  import CgFooter from '../components/CgFooter.vue'
  import CgLoader from '../components/menus/cgLoader'

  import { mapGetters, mapActions } from 'vuex'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'
  import CgUserHeader from '../components/user/CgUserHeader'
  import Profile from '../components/user/profile'
  import Favorites from '../components/user/favorites'
  import Orders from '../components/user/orders'

  export default {
    name: 'UserProfile',
    components: {
      CgLoader,
      Orders,
      Favorites,
      Profile,
      CgUserHeader,
      'navbar': Navbar,
      'cgfooter': CgFooter
    },
    mixins: [helpers, formatting],
    mounted () {
      this.tab = this.$route.query.tab
      if (this.tab !== 'orders') {
        this.tab = 'profile'
      }
    },
    data () {
      return {
        'tab': 'profil'
      }
    },
    methods: {
      changeTab (tab) {
        this.tab = tab
      },
      ...mapActions([
      ])
    },
    computed: {
      ...mapGetters({
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/UserProfile.vue